module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('v-container', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "fill-height": "",
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [(_vm.hearingDetails.pkHearing) ? _c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('details-form', {
    attrs: {
      "hearingDetails": _vm.hearingDetails,
      "id": _vm.id
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1aee2620", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1aee2620"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/src/portalhome/docketing/pages/hearingdetails/hearingdetails.vue.html
// module id = 582
// module chunks = 0